import { hash } from '@ember/helper';
import Component from '@glimmer/component';

import { t } from 'ember-intl';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface CountCharsSignature {
  Args: {
    max: number;
    min: number;
    text?: string;
  };
  Element: HTMLDivElement;
}

export default class UiCountCharsComponents extends Component<CountCharsSignature> {
  // Getter and setter
  get chars() {
    return this.args.text?.length ?? 0;
  }

  get isEmpty() {
    return this.chars < 1;
  }

  get isToLong() {
    return this.chars > this.args.max;
  }

  get isToShort() {
    return this.chars < this.args.min;
  }

  // Template
  <template>
    <div
      class={{bem
        (hash
          is-to-long=this.isToLong
          is-to-short=this.isToShort
          is-empty=this.isEmpty
        )
      }}
      ...attributes
    >
      <strong>{{this.chars}} {{t 'ui.count_chars.chars'}}</strong>
      —
      {{#if this.isToShort}}
        {{t 'ui.count_chars.to_short' min=@min}}
      {{else if this.isToLong}}
        {{t 'ui.count_chars.to_long' max=@max}}
      {{else}}
        {{t 'ui.count_chars.perfect'}}
      {{/if}}
    </div>
  </template>
}
